module.exports = __webpack_public_path__ + "static/media/logo1.136bcc81.webp";